import { render, staticRenderFns } from "./dialog_confirmar_consulta.vue?vue&type=template&id=cff72370&scoped=true&"
import script from "./dialog_confirmar_consulta.vue?vue&type=script&lang=js&"
export * from "./dialog_confirmar_consulta.vue?vue&type=script&lang=js&"
import style0 from "./dialog_confirmar_consulta.vue?vue&type=style&index=0&id=cff72370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff72370",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VContainer,VDialog,VIcon,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
